const competencies = [
  { icon: 'ri-vip-crown-line', title: 'Лидерство', desc: 'Способность влиять на команду, формировать доверие, задавать направление и добиваться результата не только за счёт должностных полномочий.' },
  { icon: 'ri-list-check-2', title: 'Постановка задач', desc: 'Умение переводить цели в понятные задачи с конкретным результатом, сроками и критериями выполнения.' },
  { icon: 'ri-user-add-line', title: 'Делегирование', desc: 'Способность передавать сотрудникам задачи и ответственность, сохраняя необходимый уровень контроля.' },
  { icon: 'ri-dashboard-line', title: 'Контроль', desc: 'Умение контролировать результат через систему контрольных точек, не превращая управление в микроменеджмент.' },
  { icon: 'ri-feedback-line', title: 'Обратная связь', desc: 'Способность обсуждать результат и поведение сотрудника так, чтобы обратная связь помогала изменению и развитию.' },
  { icon: 'ri-star-line', title: 'Мотивация', desc: 'Умение создавать условия, в которых сотрудники понимают цели, видят смысл работы и готовы брать ответственность.' },
  { icon: 'ri-chat-3-line', title: 'Коммуникация', desc: 'Способность ясно передавать информацию, договариваться и выстраивать взаимодействие внутри команды и между подразделениями.' },
  { icon: 'ri-fire-line', title: 'Управление конфликтами', desc: 'Умение разбирать причины конфликтов и переводить разногласия в конструктивное взаимодействие.' },
  { icon: 'ri-lightbulb-line', title: 'Принятие решений', desc: 'Способность принимать решения в условиях ограниченной информации, неопределённости, рисков и давления.' },
  { icon: 'ri-shake-hands-line', title: 'Переговоры', desc: 'Умение договариваться с сотрудниками, коллегами, собственниками, руководством и внешними сторонами.' },
  { icon: 'ri-arrow-left-right-line', title: 'Управление изменениями', desc: 'Способность внедрять новые процессы, правила и подходы, работая с сопротивлением сотрудников.' },
  { icon: 'ri-plant-line', title: 'Развитие сотрудников', desc: 'Умение видеть потенциал сотрудников, ставить развивающие задачи и формировать кадровый резерв.' },
];

export default function KeyCompetencies() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Ключевые компетенции современного руководителя
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Какие управленческие компетенции необходимо развивать, чтобы эффективно управлять командой и результатом
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {competencies.map((c) => (
            <div key={c.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${c.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{c.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}